/*
 * Horizontal filter bar (snippets/nc-filter-bar.liquid).
 *
 * Every change applies at once: the section is fetched with the new filter
 * params and the product grid (#ProductGridContainer) plus the filter pills
 * are swapped in place, the URL is updated with replaceState. The "Tu talla"
 * group (data-ncfb-keep) is never replaced, so assets/my-size.js keeps its
 * chosen size and re-applies it to the new cards (it watches the grid).
 */
(function () {
  if (customElements.get('nc-filter-bar')) return;

  var MOBILE = window.matchMedia('(max-width: 749px)');

  // Colour data was cleaned up (merchant, 2026-10-16): Color filter stays visible.
  // Set to true to hide it again.
  var HIDE_COLOR = false;

  // "Tu talla" across all pages of the listing (assets/nc-size-allpages.js),
  // loaded from the same assets folder as this file.
  (function loadSizeAllPages() {
    var me = document.currentScript && document.currentScript.src;
    if (!me || window.ncSizeAllPages) return;
    var s = document.createElement('script');
    s.src = me.replace(/nc-filter-bar\.js(\?[^#]*)?/, 'nc-size-allpages.js$1');
    s.defer = true;
    document.head.appendChild(s);
  })();

  class NcFilterBar extends HTMLElement {
    connectedCallback() {
      var sec = this.closest('[id^="shopify-section-"]');
      this.sectionId = sec ? sec.id.replace('shopify-section-', '') : '';
      this.overlay = this.querySelector('[data-ncfb-overlay]');
      this.controller = null;
      this.priceTimer = null;

      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.addEventListener('input', this.onInput.bind(this));
      document.addEventListener('click', this.onOutside.bind(this));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeAll(true); });

      // the sort shown when the URL has none: not written back into the URL
      var cur = new URL(window.location.href).searchParams.get('sort_by');
      var def = this.querySelector('input[name="sort_by"]:checked');
      this.defaultSort = !cur && def ? def.value : null;

      this.refreshDisc();
      this.watchSize();
      this.hideLegacy();
      this.pruneGroups();
      this.paintCount();
    }

    /* 2026-10: chips that cannot narrow anything are hidden, so no button on
       the bar is useless:
       - "Marca" with a single brand (brand collections such as Adidas);
       - any checkbox group whose options are all disabled (0 products);
       - "Color" while HIDE_COLOR is on.
       A group with an active (checked) option always stays visible, so the
       shopper can still clear it. */
    pruneGroups() {
      this.querySelectorAll('[data-ncfb-group]').forEach(function (g) {
        if (g.hasAttribute('data-ncfb-keep')) return;
        var boxes = Array.prototype.slice.call(g.querySelectorAll('input[type="checkbox"][data-ncfb-input]'));
        if (!boxes.length) { g.hidden = false; return; }
        var anyChecked = boxes.some(function (i) { return i.checked; });
        var usable = boxes.filter(function (i) { return !i.disabled; });
        var key = g.dataset.ncfbGroup || '';
        var hide = false;
        if (!anyChecked) {
          if (!usable.length) hide = true;
          else if (key === 'filter-p-vendor' && usable.length <= 1) hide = true;
          else if (HIDE_COLOR && key.indexOf('color') !== -1) hide = true;
        }
        g.hidden = hide;
        if (hide) g.style.setProperty('display', 'none', 'important');
        else g.style.removeProperty('display');
      });
    }

    /* The old drawer / floating "Filtrar" / sort dropdown are replaced by the
       bar. The search template forces them visible with !important rules, so
       an inline !important is the only way to win. */
    hideLegacy() {
      ['#main-collection-filters', '#main-search-filters', '.facets-vertical-sort', '.mobile-facets__wrapper', '.search-sort-dropdown-wrapper'].forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) {
          if (!el.closest('nc-filter-bar')) el.style.setProperty('display', 'none', 'important');
        });
      });
    }

    /* "Ver productos (140)" on the sheet buttons, kept in sync after each apply */
    paintCount(n) {
      if (n === undefined) {
        var tot = this.querySelector('[data-ncfb-total]');
        n = tot ? parseInt(tot.textContent, 10) : NaN;
      }
      if (isNaN(n)) return;
      this.querySelectorAll('.ncfb__btn--solid[data-ncfb-close]').forEach(function (b) {
        var s = b.querySelector('[data-ncfb-n]');
        if (!s) {
          s = document.createElement('span');
          s.setAttribute('data-ncfb-n', '');
          b.appendChild(document.createTextNode(' '));
          b.appendChild(s);
        }
        s.textContent = '(' + n + ')';
      });
      // page counts outside the bar ("395 productos", "249 results"): swap the number only
      document.querySelectorAll('.nc-ch__count, .search-results-count span').forEach(function (el) {
        var t = el.textContent.trim();
        if (/^\d/.test(t)) el.textContent = t.replace(/^\d[\d.,]*/, String(n));
      });
    }

    /* ---------- open / close ---------- */
    open(group) {
      this.closeAll(false);
      var btn = group.querySelector('[data-ncfb-toggle]');
      var panel = group.querySelector('.ncfb__panel');
      if (!btn || !panel) return;
      panel.hidden = false;
      btn.setAttribute('aria-expanded', 'true');
      group.classList.add('ncfb__group--open');
      if (MOBILE.matches) {
        this.overlay.hidden = false;
        document.body.classList.add('ncfb-lock');
      } else {
        // keep the dropdown inside the viewport
        panel.style.left = '';
        panel.style.right = '';
        var r = panel.getBoundingClientRect();
        if (r.right > window.innerWidth - 12) {
          panel.style.left = 'auto';
          panel.style.right = '0';
        }
      }
      this.openKey = group.dataset.ncfbGroup;
    }

    closeAll(focusBack) {
      var openGroup = this.querySelector('.ncfb__group--open');
      this.querySelectorAll('.ncfb__group--open').forEach(function (g) {
        g.classList.remove('ncfb__group--open');
        var p = g.querySelector('.ncfb__panel');
        if (p) p.hidden = true;
        var b = g.querySelector('[data-ncfb-toggle]');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (this.overlay) this.overlay.hidden = true;
      document.body.classList.remove('ncfb-lock');
      this.openKey = null;
      if (focusBack && openGroup) {
        var t = openGroup.querySelector('[data-ncfb-toggle]');
        if (t) t.focus();
      }
    }

    onOutside(e) {
      if (!this.openKey) return;
      if (this.contains(e.target) && !e.target.hasAttribute('data-ncfb-overlay')) return;
      this.closeAll(false);
    }

    /* ---------- clicks ---------- */
    onClick(e) {
      var t = e.target;
      if (t.hasAttribute && t.hasAttribute('data-ncfb-overlay')) { this.closeAll(false); return; }

      var toggle = t.closest('[data-ncfb-toggle]');
      if (toggle) {
        var g = toggle.closest('.ncfb__group');
        if (g.classList.contains('ncfb__group--open')) this.closeAll(false);
        else this.open(g);
        return;
      }
      if (t.closest('[data-ncfb-close]')) { this.closeAll(true); return; }

      var tier = t.closest('[data-tier]');
      if (tier) {
        // tapping the chosen tile again clears the discount filter
        var min = tier.dataset.tier && !tier.classList.contains('ncfb__row--on') ? parseFloat(tier.dataset.tier) : null;
        tier.closest('[data-ncfb-disc]').querySelectorAll('input[data-pct]').forEach(function (i) {
          i.checked = min !== null && parseFloat(i.dataset.pct) >= min;
        });
        this.refreshDisc();
        this.apply();
        return;
      }

      var quick = t.closest('[data-ncfb-quick] [data-lo]');
      if (quick) {
        var box = quick.closest('.ncfb__panel-body');
        var inputs = box.querySelectorAll('[data-ncfb-price] input');
        inputs[0].value = quick.dataset.lo;
        inputs[1].value = quick.dataset.hi;
        this.apply();
        return;
      }

      var clear = t.closest('[data-ncfb-clear]');
      if (clear) {
        clear.closest('.ncfb__group').querySelectorAll('[data-ncfb-input]').forEach(function (i) {
          if (i.type === 'checkbox') i.checked = false;
          else if (i.type === 'number') i.value = '';
        });
        this.refreshDisc();
        this.apply();
        return;
      }

      if (t.closest('[data-ncfb-size-clear]')) {
        var on = this.querySelector('[data-my-size-pill][aria-pressed="true"]');
        if (on) on.click();
      }
    }

    onChange(e) {
      var i = e.target;
      if (!i.matches('[data-ncfb-input]')) return;
      if (i.type === 'number') return; // handled (debounced) in onInput
      this.apply();
    }

    onInput(e) {
      var i = e.target;
      if (!i.matches('[data-ncfb-input]') || i.type !== 'number') return;
      clearTimeout(this.priceTimer);
      this.priceTimer = setTimeout(this.apply.bind(this), 700);
    }

    /* ---------- "Descuento": tier = lowest checked % when all above it are checked ---------- */
    refreshDisc() {
      var box = this.querySelector('[data-ncfb-disc]');
      if (!box) return;
      var inputs = Array.prototype.slice.call(box.querySelectorAll('input[data-pct]'));
      // theme CSS overrides [hidden] on inputs: hide the raw % checkboxes here
      inputs.forEach(function (i) { i.style.display = 'none'; });
      var checked = inputs.filter(function (i) { return i.checked; });
      var tier = '';
      if (checked.length) {
        var min = Math.min.apply(null, checked.map(function (i) { return parseFloat(i.dataset.pct); }));
        var full = inputs.every(function (i) { return (parseFloat(i.dataset.pct) >= min) === i.checked; });
        var t = [50, 40, 30, 20].filter(function (x) { return min >= x; })[0];
        tier = full ? (t ? String(t) : '') : 'custom';
      }
      box.querySelectorAll('[data-tier]').forEach(function (b) {
        var on = b.dataset.tier === tier;
        b.classList.toggle('ncfb__row--on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var chip = this.querySelector('[data-ncfb-disc-chip] span');
      if (chip && tier && tier !== 'custom') {
        chip.textContent = '-' + tier + '%' + (tier === '50' ? '' : ' ' + this.dataset.tMore);
      }
    }

    /* ---------- "Tu talla": mirror the chosen size on the pill ---------- */
    watchSize() {
      var group = this.querySelector('[data-ncfb-group="size"]');
      if (!group) return;
      var label = group.querySelector('[data-ncfb-size-label]');
      var chip = group.querySelector('[data-ncfb-toggle]');
      var self = this;
      var paint = function () {
        var on = group.querySelector('[data-my-size-pill][aria-pressed="true"]');
        var text = on ? self.dataset.tSizeShort + ' ' + on.dataset.value : label.dataset.default;
        // only touch the DOM on a real change (the label is not observed, but
        // writing the same text again would still be wasted work)
        if (label.textContent !== text) label.textContent = text;
        chip.classList.toggle('ncfb__chip--on', !!on);
      };
      // Watch only the size panel (pills are pressed / rebuilt there). The pill
      // label lives outside it, so painting can never re-trigger the observer.
      var panel = group.querySelector('.ncfb__panel');
      new MutationObserver(paint).observe(panel, { subtree: true, attributes: true, attributeFilter: ['aria-pressed'], childList: true });
      // close the sheet on mobile once a size is picked: the grid updates behind it
      group.addEventListener('click', function (e) {
        if (e.target.closest('[data-my-size-pill]') && MOBILE.matches) {
          setTimeout(function () { self.closeAll(false); }, 150);
        }
      });
      paint();
    }

    /* ---------- apply ---------- */
    buildUrl() {
      var url = new URL(window.location.href);
      Array.from(url.searchParams.keys()).forEach(function (k) {
        if (k.indexOf('filter.') === 0 || k === 'page' || k === 'sort_by' || k === 'section_id') url.searchParams.delete(k);
      });
      // drop duplicates of a key before re-adding
      var params = new URLSearchParams(url.search);
      var def = this.defaultSort;
      this.querySelectorAll('[data-ncfb-input]').forEach(function (i) {
        if (i.disabled) return;
        if (i.name === 'sort_by' && i.checked && i.value === def) return;
        if ((i.type === 'checkbox' || i.type === 'radio') && !i.checked) return;
        if (i.type === 'number' && i.value === '') return;
        params.append(i.name, i.value);
      });
      url.search = params.toString();
      return url;
    }

    apply() {
      var url = this.buildUrl();
      var fetchUrl = new URL(url.href);
      fetchUrl.searchParams.set('section_id', this.sectionId);
      var grid = document.getElementById('ProductGridContainer');
      if (grid) grid.classList.add('ncfb-loading');
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      var keepOpen = this.openKey;
      var self = this;
      fetch(fetchUrl.href, { signal: this.controller.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.getElementById('ProductGridContainer');
          if (grid && newGrid) grid.innerHTML = newGrid.innerHTML;
          var newBar = doc.querySelector('nc-filter-bar');
          if (newBar) {
            newBar.querySelectorAll('[data-ncfb-group]').forEach(function (g) {
              if (g.hasAttribute('data-ncfb-keep')) return;
              var cur = self.querySelector('[data-ncfb-group="' + g.dataset.ncfbGroup + '"]');
              if (cur) cur.replaceWith(document.importNode(g, true));
            });
            var tot = newBar.querySelector('[data-ncfb-total]');
            var curTot = self.querySelector('[data-ncfb-total]');
            if (tot && curTot) curTot.textContent = tot.textContent;
            // live count on the sheet buttons ("Ver productos (140)") and page counts
            var n = tot ? parseInt(tot.textContent, 10) : NaN;
            if (!isNaN(n)) {
              self.paintCount(n);
            }
          }
          self.refreshDisc();
          self.pruneGroups();
          if (keepOpen && keepOpen !== 'size') {
            var g2 = self.querySelector('[data-ncfb-group="' + keepOpen + '"]');
            if (g2 && !g2.hidden) self.open(g2);
          }
          window.history.replaceState({}, '', url.href);
          // let assets/my-size.js know the grid / totals changed
          document.dispatchEvent(new CustomEvent('ncfb:applied', { detail: { url: url.href } }));
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          window.location.href = url.href;
        })
        .finally(function () {
          if (grid) grid.classList.remove('ncfb-loading');
        });
    }
  }

  customElements.define('nc-filter-bar', NcFilterBar);
})();
